(function () {
    'use strict';

    a3_cabin_reports.factory('AirlineInfoFactory', AirlineInfoFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name AirlineInfoFactory
    * @description 
    *   Get crew airline infos & licenses.
    * @ngInject
    */
    function AirlineInfoFactory() {
        var service = {
            setCrewAirlineInfos: setCrewAirlineInfos,
            getCrewAirlineInfos: getCrewAirlineInfos,
            clearCrewAirlineInfosFromStorage: clearCrewAirlineInfosFromStorage
        };
      
         function setCrewAirlineInfos(airlineInfos) {
            if (airlineInfos) {
                localStorage.setItem('crewAirlineInfos', JSON.stringify(airlineInfos));
            }
        }

           function getCrewAirlineInfos() {
            return JSON.parse(localStorage.getItem('crewAirlineInfos')) || [];
        }

        /**
         * Clear airline infos from localStorage
         */
        function clearCrewAirlineInfosFromStorage() {
            localStorage.removeItem('crewAirlineInfos');
        }

        return service;
    }
})();